module.exports = __webpack_public_path__ + "img/bakery_bodyimage10.2e4ea844.jpg";